import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheckSquare, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed, ref } from "vue";
//@ts-ignore missing typedefs
import VirtualList from "vue-virtual-scroll-list";
import { useAnimationFrameResizeObserver } from "@/composables/sensors/animationFrameResizeObserver";
import { useAnimationFrameScroll } from "@/composables/sensors/animationFrameScroll";
import { Toast } from "@/composables/toast";
import { useHistoryStore } from "@/stores/historyStore";
import localize from "@/utils/localization";
import { errorMessageAsString } from "@/utils/simple-error";
import { useHistoryDragDrop } from "../../../composables/historyDragDrop";
import HistoryDropZone from "../CurrentHistory/HistoryDropZone.vue";
import MultipleViewItem from "./MultipleViewItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MultipleViewList',
    props: {
        selectedHistories: null,
        filter: { default: "" }
    },
    emits: ["update:show-modal"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCheckSquare, faPlus);
        const historyStore = useHistoryStore();
        // defineEmits below
        const scrollContainer = ref(null);
        const { arrived } = useAnimationFrameScroll(scrollContainer);
        const isScrollable = ref(false);
        useAnimationFrameResizeObserver(scrollContainer, ({ clientSize, scrollSize }) => {
            isScrollable.value = scrollSize.width >= clientSize.width + 1;
        });
        const scrolledLeft = computed(() => !isScrollable.value || arrived.left);
        const scrolledRight = computed(() => !isScrollable.value || arrived.right);
        async function createAndPin() {
            try {
                await historyStore.createNewHistory();
                if (!historyStore.currentHistoryId) {
                    throw new Error("Error creating history");
                }
                if (historyStore.pinnedHistories.length > 0) {
                    historyStore.pinHistory(historyStore.currentHistoryId);
                }
            }
            catch (error) {
                console.error(error);
                Toast.error(errorMessageAsString(error), "Error creating and pinning history");
            }
        }
        const { showDropZone, onDragEnter, onDragLeave, onDragOver, onDrop } = useHistoryDragDrop(undefined, true, true);
        async function onKeyDown(evt) {
            if (evt.key === "Enter" || evt.key === " ") {
                if (evt.target?.classList?.contains("top-picker")) {
                    await createAndPin();
                }
                else if (evt.target?.classList?.contains("bottom-picker")) {
                    emit("update:show-modal", true);
                }
            }
        }
        return { __sfc: true, historyStore, props, emit, scrollContainer, arrived, isScrollable, scrolledLeft, scrolledRight, createAndPin, showDropZone, onDragEnter, onDragLeave, onDragOver, onDrop, onKeyDown, faCheckSquare, faPlus, FontAwesomeIcon, VirtualList, localize, HistoryDropZone, MultipleViewItem };
    }
});
